module.exports = __webpack_public_path__ + "files/3e5070b257694f347b8c6540cc2e64e2.png";